import { Lightning, Utils } from '@lightningjs/sdk';

interface RowArrowButtonTemplateSpec extends Lightning.Component.TemplateSpecLoose {
    direction?: 'left' | 'right';
}

export default class RowArrowButton extends Lightning.Component<RowArrowButtonTemplateSpec> {
    _direction: 'left' | 'right' = 'left';

    static override _template(): Lightning.Component.Template<RowArrowButtonTemplateSpec> {
        return {
            w: 100,
            h: 100,
            collision: true,
            rect: true,
            color: 0xcc000000,
            shader: {
                type: Lightning.shaders.RoundedRectangle,
                radius: 50
            },
            IconClipping: {
                mount: 0.5,
                x: 50,
                y: 50,
                w: 72,
                h: 144,
                scale: 0.6,
                clipping: true,
                Sprite: {
                    src: Utils.asset('images/arrows.png'),
                    x: -144, // Default to left arrow
                    y: 0,
                }
            }
        };
    }

    set direction(v: 'left' | 'right') {
        this._direction = v;
        if (v === 'right') {
            this.tag('Sprite').x = -216; // 144 + 72
        } else {
            this.tag('Sprite').x = -144; // 144
        }
    }

    override _focus() {
        this.patch({ smooth: { scale: 1.1 } });
    }

    override _unfocus() {
        this.patch({ smooth: { scale: 1.0 } });
    }

    override _handleEnter() {
        this._handleClick();
    }

    _handleClick() {
        if (this._direction === 'left') {
            this.fireAncestors('$onLeftArrowClick');
        } else {
            this.fireAncestors('$onRightArrowClick');
        }
    }

    _handleHover() {
        this.fireAncestors('$GridArrowHover', true);
    }

    _handleUnhover() {
        this.fireAncestors('$GridArrowHover', false);
    }
}
